// JavaScript source code
import initialstate from "../initialstate";
import * as types from '../../actions/actiontypes';

function knowledgeTechnologyReducer(state = initialstate.knowledgeTechnologies, action) {
	switch (action.type) {
		case types.GET_ALL_KNOWLEDGE_TECHNOLOGIES:
			return action.response?.knowledgeITApplications || state;

		default:
			return state;
	}
}

export default knowledgeTechnologyReducer;
